export const updateScrollOffset = () => {
  const header = document.querySelector("[data-nav-header]");
  const navHeight = header ? (header as HTMLElement).offsetHeight : 0;
  document.documentElement.style.setProperty('--header-height', `${navHeight}px`);
};
